import React, { Component } from 'react';
import { Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';
import * as moment from 'moment';
import axios from 'axios'
import { getOrderKey, logDashboardAction} from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'


class UpdateStatusAlgolia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderType: '',
            orderTypeChoices: [],
            
        }
    }

    
    componentDidMount() {
        //SHIRT COLORS
    
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleDropDownChanges = (value) => {
        console.log("ddx3 handleDropDownChanges");
        console.log('ddx31 You\'ve sss:', value);
        console.log("ddx32 category alone:" + value.category);
        console.log('ddx33 You\'ve selected:', value.value + " " + value.category);
        console.log("ddx34 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("ddx35 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("ddx36 newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    updateStatus = () => {
        console.log("ddx37 ++++++++++++++ selectDesigner");
        // function updateStatus(orderId, status, user) {
       // FbUtils.updateStatus(this.props.order.key, this.state.status, this.props.user.email);
       FbUtils.updateStatus(getOrderKey(this.props.order), this.state.status, this.props.user.email);

       let updateString = this.props.user.email+ " updated order "+this.props.order.order_num+" from "+this.props.order.status +" to "+this.state.status
       console.log("ddx37 updateString:"+updateString);
       logDashboardAction(updateString, this.props.user.email, this.props.order.order_num,"updateStatus");

       let updateText = this.state.status+" - "+this.props.user.email.substring(0,10);
       FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);

       this.setState({
        status:''
       })

       setTimeout(this.props.setRefreshToTrue, 5000);
       setTimeout(this.props.setRefreshToFalse, 10000);
    }

    render() {

        const wholeUi = 
             <div>
                <Divider horizontal>{'EDIT STATUS!'}</Divider>
            
                <Select
                    name="form-field-name"
                    value={this.state.status}
                    options={this.props.orderStatuses}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <Button fluid color='red' onClick={this.updateStatus}> CHANGE STATUS</Button>

            </div>
  


        return (
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default UpdateStatusAlgolia;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/UpdateStatus/UpdateStatusAlgolia.js